<template>
  <div class="w-1/2">
    <h3 class="mb-2 text-left">{{ props.title }} : {{ amountWithUnit(props.current,2) }} / {{ amountWithUnit(props.max,2) }}  used</h3>
    <div class="flex flex-row items-center">


            <div ref="greenBar" :style="{width: greenGrayPercentage }" class=" w-full bg-gray-200 overflow-visible rounded-lg">
              <div ref="greenRevenueBar" class="bg-green-400 py-2 rounded-lg" :style="{width: greenPercentage }"></div>
            </div>
            <div ref="orangeBar" :style="{width: orangeGrayPercentage }" class="  bg-gray-200 overflow-visible rounded-lg">
              <div  ref="orangeRevenueBar" class="bg-orange-400 py-2 rounded-r-lg" :style="{width: orangePercentage }"></div>
            </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref} from "vue";
let props = defineProps( {
  source: String,
  title: String,
  current: Number,
  max:Number,
  unit:String,
})
let greenGrayPercentage = ref("100%");
let orangeGrayPercentage = ref('0%');
let orangePercentage = ref(null);
let greenPercentage = ref(null);
let greenBar = ref(null);
let orangeBar = ref(null);
let greenRevenueBar = ref(null);
let orangeRevenueBar = ref(null);

function amountWithUnit(amount, decimals = 0)
{
  if (props.title === "Revenue")
  {
    return props.unit + " " + amountToReadable(amount, decimals);
  }
  else
  {
    return amount + " " + props.unit;
  }
}


onMounted (  () => {
  greenPercentage.value = Math.floor((props.current / props.max)*100) ;
  if (greenPercentage.value > 100)
  {
    greenPercentage.value = '100%';
    let orange = ((props.current - props.max )/ props.max) * 100;
    if (orange >= 100)
    {
      greenGrayPercentage.value = '0%';
      orangeRevenueBar.value.classList.add('rounded-lg')
    }
    else
    {
      greenGrayPercentage.value = 100 - orange + "%";
    }
    orangeGrayPercentage.value = orange + '%';
    orangePercentage.value = '100%'
    greenRevenueBar.value.classList.remove('rounded-lg');
    greenRevenueBar.value.classList.add('rounded-l-lg');
  }
  else
  {
    greenPercentage.value = greenPercentage.value + '%';
  }
})
function amountToReadable(amount, decimals = 0)
{
  let res = 0;
  if (amount >= 1000)
  {
    res = (amount / 1000).toFixed(decimals)+ "K"
  }
  return res;
}
</script>
